// Charge Trading module - English
export default {
  tabs: {
    summary: "Summary",
    counterparty: "Counterparty",
    details: "Details",
  },
  common: {
    totalPrefix: "Total ",
    totalSuffix: " items",
    download: "Download",
    downloadFilename: "Details",
    loading: "Loading...",
    empty: "No Data",
    copySuccess: "Copied!",
  },
  summary: {
    columns: {
      title: "Direction",
      totalCount: "Tx Count",
      currency: "Currency",
      totalQuantity: "Total Quantity",
    },
  },
  rival: {
    columns: {
      title: "Direction",
      counterparty: "Counterparty",
      totalCount: "Tx Count",
      currency: "Currency",
      totalQuantity: "Total Quantity",
    },
    directions: {
      ALL: "Both",
      INFLOW: "Inflow",
      OUTFLOW: "Outflow",
    },
  },
  details: {
    columns: {
      title: "Direction",
      counterparty: "Counterparty",
      currency: "Currency",
      quantity: "Quantity",
      txTime: "Tx Time",
      hash: "Tx Hash",
    },
  },
};
